import { ScopeOfWorkStep } from "../context/scope-of-work.types";

export const SCOPE_OF_WORK_CONFIG = [
  {
    id: ScopeOfWorkStep.Categories,
    label: "Categories",
    description: "Select between Commercial or Residential services",
  },
  {
    id: ScopeOfWorkStep.TypeOfPlaces,
    label: "Type of Places",
    description: "Choose the type of location to clean",
  },
  {
    id: ScopeOfWorkStep.TypeOfService,
    label: "Type of Service",
    description: "Select the service type you need",
  },
  {
    id: ScopeOfWorkStep.Areas,
    label: "Areas",
    description: "Define the areas to be cleaned",
  },
  {
    id: ScopeOfWorkStep.Objects,
    label: "Objects",
    description: "Select additional objects or items",
  },
  {
    id: ScopeOfWorkStep.SpecialRequests,
    label: "Special Requests",
    description: "Add any special requirements",
  },
  {
    id: ScopeOfWorkStep.Summary,
    label: "Summary",
    description: "Review your scope of work details",
  },
];
